// extracted by mini-css-extract-plugin
export default {"input":"Sca-z","button":"Tca-z","selected":"Uca-z","unavailable":"Vca-z","oos":"Wca-z","paperCutDisabledOverlay":"Xca-z","image":"Yca-z"};